export const equipmentActionTypes = {
    'equipment/setAllEQ': 'equipment/setAllEQ',
    'equipment/updateEquipmentTable': 'equipment/updateEquipmentTable',
    'equipment/update': 'equipment/update',
    'equipment/updateFromEquipmentPage':'equipment/updateFromEquipmentPage', 
};
